/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 803
// module chunks = 1